import { ENV } from '@wolffun/env-var';
export const THETAN_COIN_CONTRACT_ADDRESS = (() => {
  const apis = {
    production: '0x24802247bd157d771b7effa205237d8e9269ba8a',
    uat: '0x21f9b2137d4e1b83d09ea373be773a986c0e3f90',
    staging: '0x21f9b2137d4e1b83d09ea373be773a986c0e3f90',
    test: '0x21f9b2137d4e1b83d09ea373be773a986c0e3f90'
  };
  return apis[ENV];
})();
export const BUSD_CONTRACT_ADDRESS = (() => {
  const apis = {
    production: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    uat: '0x1d7256253f06cd8e1740ba0edda4d70b1a852b08',
    staging: '0x1d7256253f06cd8e1740ba0edda4d70b1a852b08',
    test: '0x1d7256253f06cd8e1740ba0edda4d70b1a852b08'
  };
  return apis[ENV];
})();
export const WBNB_CONTRACT_ADDRESS = (() => {
  const apis = {
    production: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
    uat: '0x15c9e651b5971feb66e19fe9e897be6bdc3e841a',
    staging: '0x15c9e651b5971feb66e19fe9e897be6bdc3e841a',
    test: '0x15c9e651b5971feb66e19fe9e897be6bdc3e841a'
  };
  return apis[ENV];
})();
export const BUSDT_CONTRACT_ADDRESS = (() => {
  const apis = {
    production: '0x55d398326f99059ff775485246999027b3197955',
    uat: '0xdfe8FB982f4E24DC37Ae8860A2814EF298daa85d',
    staging: '0xdfe8FB982f4E24DC37Ae8860A2814EF298daa85d',
    test: '0xdfe8FB982f4E24DC37Ae8860A2814EF298daa85d'
  };
  return apis[ENV];
})();
export const THETAN_GEM_CONTRACT_ADDRESS = (() => {
  const apis = {
    production: '0x9fd87aefe02441b123c3c32466cd9db4c578618f',
    uat: '0x948deddc3d3cf03017fd4e42cc9ac874402d0bb9',
    staging: '0x948deddc3d3cf03017fd4e42cc9ac874402d0bb9',
    test: '0x948deddc3d3cf03017fd4e42cc9ac874402d0bb9'
  };
  return apis[ENV];
})(); // used for buy, sell hero, this is contract address

export const THETA_MARKETPLACE_WALLET_ADDRESS = (() => {
  const apis = {
    production: '0x39A4d9815AAe1131D41ED22CD2B45dE9e75447cA',
    uat: '0xe9796e718f09448e15F831349B32902b5329cF6C',
    staging: '0x091B15199956f893f03F66518b271c84739E251e',
    test: '0x091B15199956f893f03F66518b271c84739E251e'
  };
  return apis[ENV];
})(); // used for buy thetan box, this is contract address

export const THETAN_BOX_PAYMENT_ADDRESS = (() => {
  const apis = {
    production: '0x46F59FF6B535F8671fC6ccf14bF989Ff02CEa173',
    uat: '0x2286EB38330ABBe24ef6dF59c6Cd766B7f9367df',
    staging: '0xCec0D2b90759BD2c9b35e9C3030287858C02E7d4',
    test: '0xCec0D2b90759BD2c9b35e9C3030287858C02E7d4'
  };
  return apis[ENV];
})(); // used for buy tournament ticket, this is contract address

export const TOURNAMENT_TICKET_PAYMENT_ADDRESS = (() => {
  const apis = {
    production: '',
    uat: '0xFc3D63dF573a9Bc544b4756Ffc68743e60A2F621',
    staging: '0xFc3D63dF573a9Bc544b4756Ffc68743e60A2F621',
    test: '0xFc3D63dF573a9Bc544b4756Ffc68743e60A2F621'
  };
  return apis[ENV];
})(); // used for hero rental, this is contract address

export const HERO_RENTAL_ADDRESS = (() => {
  const apis = {
    production: '0x1C4E9F87c7F2bCd80c89A1999d776461d41545b9',
    uat: '0x93792733f6a437C44E10359715e1348857250834',
    staging: '0xB897858E4e8379E790F69385D8fDc69F7f723c8A',
    test: '0xB897858E4e8379E790F69385D8fDc69F7f723c8A'
  };
  return apis[ENV];
})(); // used for mint hero, this is contract address

export const MINT_HERO_ADDRESS = (() => {
  const apis = {
    production: '0x04e6bd361B32C590fF3a0C4CBB2E2b8D901E7d1c',
    uat: '0x602f8ee911D76AD05A585d8782ad892984480239',
    staging: '0x233d32D29347533B4099E8AB357D51aA205B733a',
    test: '0x233d32D29347533B4099E8AB357D51aA205B733a'
  };
  return apis[ENV];
})(); // used for mint cosmetic, this is contract address

export const MINT_COSMETIC_ADDRESS = (() => {
  const apis = {
    production: '0x7A3a062256C10440Dfab9AF3a74A96c9Adfe3AB0',
    uat: '0x908FB7c9e0EF4917B09fD8046FB83eFf01563E3A',
    staging: '0x675b83654feB97C14Bcb223f0f3c2D3d589eBE22',
    test: '0x675b83654feB97C14Bcb223f0f3c2D3d589eBE22'
  };
  return apis[ENV];
})(); // used for convert THC->THG, this is contract address

export const CONVERT_THC_PAYMENT_ADDRESS = (() => {
  const apis = {
    production: '0xd18f07ECa199ED1a3dacEe3d999e4D9A39d28557',
    uat: '0x7A8831C51e71F56E5d0e5590f4b9c5B760657b9d',
    staging: '0x7A8831C51e71F56E5d0e5590f4b9c5B760657b9d',
    test: '0x7A8831C51e71F56E5d0e5590f4b9c5B760657b9d'
  };
  return apis[ENV];
})(); // used for check owner nft item

export const NFT_CONTRACT_ADDRESS = (() => {
  const apis = {
    production: '0x98eb46cbf76b19824105dfbcfa80ea8ed020c6f4',
    uat: '0xF8701737942090978b6cF3213F12F32c16128aa8',
    staging: '0x6DA7799D302aDf6DCD43C62472a48B3a5D5e172c',
    test: '0x6DA7799D302aDf6DCD43C62472a48B3a5D5e172c'
  };
  return apis[ENV];
})(); // used for user deposit token

export const THETAN_COIN_DEPOSIT_ADDRESS = (() => {
  const apis = {
    production: '0x74dA65A951c106DE36Da72cA46c34fD4C54D650b',
    uat: '0xb0EABDf5141278a7Da9931c8595E3FF3c5aDeBE9',
    staging: '0xb0EABDf5141278a7Da9931c8595E3FF3c5aDeBE9',
    test: '0xb0EABDf5141278a7Da9931c8595E3FF3c5aDeBE9'
  };
  return apis[ENV];
})();
export const THETAN_GEM_DEPOSIT_ADDRESS = (() => {
  const apis = {
    production: '0x2349Aa94Ed4c3a513010eD6a55e188E8D5247d6F',
    uat: '0xb0EABDf5141278a7Da9931c8595E3FF3c5aDeBE9',
    staging: '0xb0EABDf5141278a7Da9931c8595E3FF3c5aDeBE9',
    test: '0xb0EABDf5141278a7Da9931c8595E3FF3c5aDeBE9'
  };
  return apis[ENV];
})(); // used for staking program, this is contract address

export const STAKING_ADDRESS = (() => {
  const apis = {
    production: '0xaaccd344c06bfEF6F613BCC8e56f4BBcBF8cB66D',
    uat: '0xbFcbB232adBF56cCFA32D8b15258E0df5B036Fe4',
    staging: '0x749C708066185FadE4d043c1722F56613f3F8795',
    test: '0x749C708066185FadE4d043c1722F56613f3F8795'
  };
  return apis[ENV];
})(); // used for staking program, this is contract address

export const CLAIM_TOKEN_ADDRESS = (() => {
  const apis = {
    production: '0x458363e309a2638c08afb2621255ef53eACB1c33',
    uat: '0xa9aD1595d804ec3213d33BDc447d0FFE59dCe6cb',
    staging: '0x4077181364106e1cA521B7350D9A41BD2E16Bff7',
    test: '0x4077181364106e1cA521B7350D9A41BD2E16Bff7'
  };
  return apis[ENV];
})(); // used for deposit, this is contract address

export const DEPOSIT_TOKEN_CONTRACT_ADDRESS = (() => {
  const apis = {
    production: '0x2df3f5782e1c8f2f518e0b3f15e4f27d62a4a3b2',
    uat: '0xbA01E92eA9B940745f89785fC9cED4DDc17Da450',
    staging: '0xbA01E92eA9B940745f89785fC9cED4DDc17Da450',
    test: '0xbA01E92eA9B940745f89785fC9cED4DDc17Da450'
  };
  return apis[ENV];
})(); // used for cosmetic nft item

export const COSMETIC_NFT_CONTRACT_ADDRESS = (() => {
  const apis = {
    production: '0x257e7cF74d68DdbE291420e109E18cBee62475f1',
    uat: '0xB42be9670886112Ff17Ef239ACa77539666729CB',
    staging: '0x9127B2ced41D0F0fcF080d3E979B54d95DF07565',
    test: '0x9127B2ced41D0F0fcF080d3E979B54d95DF07565'
  };
  return apis[ENV];
})(); // used for buy private sale

export const PRIVATE_SALE_CONTRACT_ADDRESS = (() => {
  const apis = {
    production: '0xdc5c821ba229064782ebE5630E9DeCB686979671',
    uat: '0xA6Ad7fbc68AccAA1DE32d9054278D438BA0f595E',
    staging: '0x17e2682e5E28F41D5129DF232Bd6F8EA42C61984',
    test: '0x17e2682e5E28F41D5129DF232Bd6F8EA42C61984'
  };
  return apis[ENV];
})(); // used for fuse hero

export const FUSION_HERO_CONTRACT_ADDRESS = (() => {
  const apis = {
    production: '0x2dB1C89Bb1958029F585fA96b41dF9323e8efD9E',
    uat: '0x784082a4560b7caF0589081f0BF7B65e750Db63c',
    staging: '0xeDF1793bB0F05B2E7bFe323842FE88f3d3796cEE',
    test: '0xeDF1793bB0F05B2E7bFe323842FE88f3d3796cEE'
  };
  return apis[ENV];
})(); // production contract address

export const THG_EXCHANGE_CONTRACT_ADDRESS = '0x9fd87aefe02441b123c3c32466cd9db4c578618f'; // production contract address
// TODO: update contract address when production release

export const THC_EXCHANGE_CONTRACT_ADDRESS = '0x24802247bd157d771b7effa205237d8e9269ba8a'; // production contract address

export const BUSD_EXCHANGE_CONTRACT_ADDRESS = '0xe9e7cea3dedca5984780bafc599bd69add087d56'; // production contract address

export const WBNB_EXCHANGE_CONTRACT_ADDRESS = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c'; // production contract address

export const BNB_EXCHANGE_CONTRACT_ADDRESS = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'; // production contract address

export const BUSDT_EXCHANGE_CONTRACT_ADDRESS = '0x55d398326f99059ff775485246999027b3197955';